"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useEmitTypingIndicator;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useEmitTypingIndicator() {
  return (0, _useWebChatAPIContext.default)().emitTypingIndicator;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VFbWl0VHlwaW5nSW5kaWNhdG9yLnRzIl0sIm5hbWVzIjpbInVzZUVtaXRUeXBpbmdJbmRpY2F0b3IiLCJlbWl0VHlwaW5nSW5kaWNhdG9yIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxzQkFBVCxHQUE4QztBQUMzRCxTQUFPLHFDQUF1QkMsbUJBQTlCO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VXZWJDaGF0QVBJQ29udGV4dCBmcm9tICcuL2ludGVybmFsL3VzZVdlYkNoYXRBUElDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlRW1pdFR5cGluZ0luZGljYXRvcigpOiAoKSA9PiB2b2lkIHtcbiAgcmV0dXJuIHVzZVdlYkNoYXRBUElDb250ZXh0KCkuZW1pdFR5cGluZ0luZGljYXRvcjtcbn1cbiJdfQ==